import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchPageBySlug } from '../lib/cms'
import useMeta from '../hooks/useMeta'
import { ArrowRight, ImageIcon } from 'lucide-react'

export default function Galleri() {
  const [pageData, setPageData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function loadData() {
      const data = await fetchPageBySlug('galleri')
      setPageData(data)
      setLoading(false)
    }
    loadData()
  }, [])

  // Set metadata
  useMeta({
    title: 'Galleri · JP Stål og Rør ApS',
    description: 'Se tidligere opgaver her. Klik ind på galleriet og se mere.',
    ogTitle: 'Galleri · JP Stål og Rør ApS',
    ogDescription: 'Se tidligere opgaver her. Klik ind på galleriet og se mere.',
    ogImage: 'https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/7b8141e3-1088-4763-9902-e77754db9a16.jpg',
    canonicalUrl: 'https://jpstaalogroer.dk/galleri'
  })

  if (loading) {
    return (
      <div className="min-h-screen bg-silver-200 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500"></div>
      </div>
    )
  }

  const projects = [
    {
      title: 'Brud i Farum',
      slug: 'brud-i-farum',
      image: 'https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/0855b3db-da73-4da7-80ca-41a1a242ff0a.jpg',
      desc: 'Udgravning og udbedring af brud på fjernvarmerør i Farum.'
    },
    {
      title: 'Projekt (Certifikatsvejsning)',
      slug: 'projekt-4',
      image: 'https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/2d0584c5-7273-404d-843f-0bb531fe0469.jpg',
      desc: 'Certifikatsvejsning udført efter de højeste standarder.'
    },
    {
      title: 'Projekt (Muffemontage)',
      slug: 'projekt-3',
      image: 'https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/3a2b3d1f-d3d3-4a55-8faa-8f84bcfcb93f.jpeg',
      desc: 'Muffemontage og isolering af fjernvarmerør.'
    },
    {
      title: 'Projekt (Udgravning & Svejsning)',
      slug: 'projekt-2',
      image: 'https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/98e0ec09-72e9-4f17-9c14-50df575a9a1b.jpeg',
      desc: 'Udgravning og svejsning af fjernvarmerør i terræn.'
    },
    {
      title: 'Projekt (Svejsning & Muffe)',
      slug: 'projekt',
      image: 'https://assets.auxodev.dk/assets/e3c28b93-c07f-41a2-89fa-cab890739d18/d1a201a2-613d-4546-aa68-2fafe952f02e.jpeg',
      desc: 'Komplet svejsning og efterfølgende muffemontering.'
    }
  ]

  return (
    <div className="bg-silver-200 text-slate-900 min-h-screen py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Page Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-600">Referencer</span>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-950 uppercase tracking-tight mt-2 mb-6">
            Galleri &amp; Projekter
          </h1>
          <p className="text-slate-700 text-lg leading-relaxed">
            Se et udvalg af vores seneste arbejdsopgaver inden for svejsning af fjernvarmerør, muffemontering og certifikatsvejsning. Vi leverer solidt, holdbart håndværk til tiden.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, idx) => (
            <div
              key={project.slug}
              className="bg-silver-100 border border-silver-400 rounded-sm overflow-hidden flex flex-col justify-between shadow-md group hover:border-silver-500 transition-all duration-300"
            >
              <div>
                <div className="aspect-[4/3] bg-silver-300 relative overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute top-3 left-3 bg-silver-100/90 border border-silver-400 p-1.5 rounded-sm text-amber-600 shadow-xs">
                    <ImageIcon className="w-4 h-4" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-slate-950 uppercase tracking-wider mb-2 group-hover:text-amber-600 transition-colors duration-200">
                    {project.title}
                  </h3>
                  <p className="text-slate-700 text-xs leading-relaxed">
                    {project.desc}
                  </p>
                </div>
              </div>
              <div className="p-6 pt-0">
                <Link
                  to={`/${project.slug}`}
                  className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-amber-600 hover:text-amber-700 transition-colors duration-200 cursor-pointer"
                >
                  <span>Se reference</span>
                  <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}
